module.exports = __webpack_public_path__ + "static/media/logo.e4133f50.svg";